import * as R from 'ramda'
import axios from 'axios'
import uuid from 'uuid/v4'

export function getStartingPreferences(prefills, preferences) {
  const prefilledPreferences = []

  const industries = R.path(['company', 'industries'], prefills)

  if (industries) {
    const industryName = industries[0]?.name

    const industryMappings = {
      'Animation and Comics': 'Arts and Entertainment',
      'Arts and Entertainment': 'Arts and Entertainment',
      'Books and Literature': 'Arts and Entertainment',
      Humor: 'Arts and Entertainment',
      Music: 'Arts and Entertainment',
      'Performing Arts': 'Arts and Entertainment',
      'TV Movies and Streaming': 'Arts and Entertainment',
      'Visual Arts and Design': 'Arts and Entertainment',
      'Business and Consumer Services': 'Business and Consumer Services',
      'Business Services': 'Business and Consumer Services',
      'Marketing and Advertising': 'Marketing and Advertising',
      'Online Marketing': 'Marketing and Advertising',
      'Publishing and Printing': 'Business and Consumer Services',
      'Real Estate': 'Real Estate',
      'Relocation and Household Moving': 'Business and Consumer Services',
      'Shipping and Logistics': 'Shipping and Logistics',
      Textiles: 'Business and Consumer Services',
      'Community and Society': 'Community and Society',
      Decease: 'Community and Society',
      'Faith and Beliefs': 'Community and Society',
      'Holidays and Seasonal Events': 'Community and Society',
      Philanthropy: 'Philanthropy',
      'Romance and Relationships': 'Community and Society',
      'Advertising Networks': 'Computers Electronics and Technology',
      'Computer Hardware': 'Computers Electronics and Technology',
      'Computer Security': 'Computer Security',
      'Computers Electronics and Technology': 'Computers Electronics and Technology',
      'Consumer Electronics': 'Consumer Electronics',
      Email: 'Computers Electronics and Technology',
      'File Sharing and Hosting': 'Computers Electronics and Technology',
      'Graphics Multimedia and Web Design': 'Computers Electronics and Technology',
      'Programming and Developer Software': 'Computers Electronics and Technology',
      'Search Engines': 'Computers Electronics and Technology',
      'Social Networks and Online Communities': 'Social Networks and Online Communities',
      Telecommunications: 'Telecommunications',
      'Web Hosting and Domain Names': 'Web Hosting and Domain Names',
      'Artificial Intelligence and Machine Learning':
        'Artificial Intelligence and Machine Learning',
      'Augmented Reality and Virtual Reality': 'Computers Electronics and Technology',
      'Blockchain and Cryptocurrency': 'Blockchain and Cryptocurrency',
      'Cloud Services and Computing': 'Cloud Services and Computing',
      'Smart Homes and Home Automation': 'Computers Electronics and Technology',
      'Drone Technology': 'Computers Electronics and Technology',
      'Video Game Design and Development': 'Video Game Design and Development',
      'Green and Renewable Technology': 'Green and Renewable Technology',
      Auctions: 'E-commerce and Shopping',
      Classifieds: 'E-commerce and Shopping',
      'Coupons and Rebates': 'E-commerce and Shopping',
      'E-commerce and Shopping': 'E-commerce and Shopping',
      Marketplace: 'Marketplace',
      'Price Comparison': 'E-commerce and Shopping',
      Tickets: 'Tickets',
      'Accounting and Auditing': 'Accounting and Auditing',
      'Banking Credit and Lending': 'Finance',
      Finance: 'Finance',
      'Financial Planning and Management': 'Finance',
      Insurance: 'Insurance',
      Investing: 'Investing',
      Beverages: 'Food and Drink',
      'Cooking and Recipes': 'Food and Drink',
      'Food and Drink': 'Food and Drink',
      Groceries: 'Food and Drink',
      'Restaurants and Delivery': 'Restaurants and Delivery',
      'Vegetarian and Vegan': 'Food and Drink',
      Bingo: 'Gambling',
      Casinos: 'Gambling',
      Gambling: 'Gambling',
      Lottery: 'Gambling',
      Poker: 'Gambling',
      'Sports Betting': 'Gambling',
      'Board and Card Games': 'Games',
      Games: 'Games',
      'Puzzles and Brainteasers': 'Games',
      'Roleplaying Games': 'Games',
      'Video Games Consoles and Accessories': 'Games',
      Addictions: 'Health',
      'Alternative and Natural Medicine': 'Health',
      'Biotechnology and Pharmaceuticals': 'Biotechnology and Pharmaceuticals',
      'Childrens Health': 'Health',
      'Dentist and Dental Services': 'Dentist and Dental Services',
      'Developmental and Physical Disabilities': 'Health',
      'Geriatric and Aging Care': 'Health',
      Health: 'Health',
      'Health Conditions and Concerns': 'Health',
      Medicine: 'Medicine',
      'Mens Health': 'Health',
      'Mental Health': 'Health',
      'Nutrition Diets and Fitness': 'Health',
      Pharmacy: 'Health',
      'Public Health and Safety': 'Health',
      'Womens Health': 'Health',
      'Aerospace and Defense': 'Heavy Industry and Engineering',
      Agriculture: 'Agriculture',
      Architecture: 'Architecture',
      'Chemical Industry': 'Heavy Industry and Engineering',
      'Construction and Maintenance': 'Construction and Maintenance',
      'Energy Industry': 'Energy Industry',
      'Heavy Industry and Engineering': 'Heavy Industry and Engineering',
      'Metals and Mining': 'Heavy Industry and Engineering',
      'Waste Water and Environmental': 'Heavy Industry and Engineering',
      'Ancestry and Genealogy': 'Hobbies and Leisure',
      'Antiques and Collectibles': 'Hobbies and Leisure',
      'Camping Scouting and Outdoors': 'Hobbies and Leisure',
      Crafts: 'Hobbies and Leisure',
      'Hobbies and Leisure': 'Hobbies and Leisure',
      Models: 'Hobbies and Leisure',
      Photography: 'Hobbies and Leisure',
      Furniture: 'Home and Garden',
      Gardening: 'Home and Garden',
      'Home and Garden': 'Home and Garden',
      'Home Improvement and Maintenance': 'Home and Garden',
      'Interior Design': 'Home and Garden',
      'Human Resources': 'Other',
      'Jobs and Career': 'Other',
      'Jobs and Employment': 'Other',
      Government: 'Government',
      'Immigration and Visas': 'Government',
      'Law and Government': 'Law and Government',
      'Law Enforcement and Protective Services': 'Government',
      Legal: 'Legal',
      'National Security': 'Government',
      'Beauty and Cosmetics': 'Beauty and Cosmetics',
      Childcare: 'Lifestyle',
      'Fashion and Apparel': 'Fashion and Apparel',
      'Gifts and Flowers': 'Gifts and Flowers',
      'Jewelry and Luxury Products': 'Jewelry and Luxury Products',
      Lifestyle: 'Lifestyle',
      Tobacco: 'Lifestyle',
      Weddings: 'Lifestyle',
      'Luxury Goods and Brands': 'Jewelry and Luxury Products',
      'Luxury Travel and Experiences': 'Jewelry and Luxury Products',
      'High-End Fashion and Accessories': 'Jewelry and Luxury Products',
      'Luxury Real Estate': 'Jewelry and Luxury Products',
      'Fine Dining and Gourmet Cuisine': 'Jewelry and Luxury Products',
      'Luxury Cars and Automobiles': 'Jewelry and Luxury Products',
      'Fine Art and Collectibles': 'Jewelry and Luxury Products',
      'Luxury Lifestyle and Services': 'Jewelry and Luxury Products',
      'Luxury Watches and Jewelry': 'Jewelry and Luxury Products',
      'News and Media': 'News and Media',
      Animals: 'Pets and Animals',
      Birds: 'Pets and Animals',
      'Fish and Aquaria': 'Pets and Animals',
      Horses: 'Pets and Animals',
      'Pet Food and Supplies': 'Pets and Animals',
      Pets: 'Pets and Animals',
      'Pets and Animals': 'Pets and Animals',
      'Dictionaries and Encyclopedias': 'Other',
      Maps: 'Other',
      'Public Records and Directories': 'Science and Education',
      'Reference Materials': 'Other',
      Astronomy: 'Science and Education',
      Biology: 'Science and Education',
      'Business Training': 'Science and Education',
      Chemistry: 'Science and Education',
      'Earth Sciences': 'Science and Education',
      Education: 'Science and Education',
      'Environmental Science': 'Science and Education',
      'Grants Scholarships and Financial Aid': 'Science and Education',
      History: 'Science and Education',
      'Libraries and Museums': 'Science and Education',
      Literature: 'Science and Education',
      Math: 'Science and Education',
      Philosophy: 'Science and Education',
      Physics: 'Science and Education',
      'Science and Education': 'Science and Education',
      'Social Sciences': 'Science and Education',
      'Universities and Colleges': 'Universities and Colleges',
      Weather: 'Science and Education',
      'American Football': 'Sports',
      Baseball: 'Sports',
      Basketball: 'Sports',
      Boxing: 'Sports',
      Climbing: 'Sports',
      'Cycling and Biking': 'Sports',
      'Extreme Sports': 'Sports',
      'Fantasy Sports': 'Sports',
      Fishing: 'Sports',
      Golf: 'Sports',
      'Hunting and Shooting': 'Sports',
      'Martial Arts': 'Sports',
      Rugby: 'Sports',
      Running: 'Sports',
      Soccer: 'Sports',
      Sports: 'Sports',
      Tennis: 'Sports',
      Volleyball: 'Sports',
      'Water Sports': 'Sports',
      'Winter Sports': 'Sports',
      'Accommodation and Hotels': 'Accommodation and Hotels',
      'Air Travel': 'Travel and Tourism',
      'Car Rentals': 'Car Rentals',
      'Ground Transportation': 'Travel and Tourism',
      'Tourist Attractions': 'Travel and Tourism',
      'Transportation and Excursions': 'Transportation and Excursions',
      'Travel and Tourism': 'Travel and Tourism',
      'Automotive Industry': 'Vehicles',
      Aviation: 'Vehicles',
      Boats: 'Boats',
      'Makes and Models': 'Vehicles',
      Motorcycles: 'Vehicles',
      Motorsports: 'Vehicles',
      Vehicles: 'Vehicles',
      'Adult Entertainment': 'Adult',
      'Adult Toys and Products': 'Adult',
      'Adult Dating and Hookup': 'Adult',
      'Adult Content and Media': 'Adult',
      'Adult Forums and Communities': 'Adult',
      'Sexual Health and Education': 'Adult',
    }

    const mappedIndustryName = industryMappings[industryName] || industryName

    const industryPreference = getPreferenceByNameAndType(
      mappedIndustryName,
      'industry',
      preferences
    )

    if (industryPreference) {
      industryPreference.type = 'industry'
      prefilledPreferences.push(industryPreference)
    }
  }

  const employees = R.path(['company', 'employees'], prefills)
  const employeeCountToRangemapper = {
    1: '1',
    2: '2-10',
    11: '11-50',
    51: '51-200',
    201: '201-500',
    501: '501-1000',
    1001: '1001-5000',
    5001: '5001-10000',
    10001: '10001+',
  }

  if (employees) {
    const employeeRange = employeeCountToRangemapper[employees]

    const sizePreference = getPreferenceByNameAndType(employeeRange, 'size', preferences)
    if (sizePreference) {
      sizePreference.type = 'size'
      prefilledPreferences.push(sizePreference)
    }
  }

  const country = R.path(['company', 'location', 'country'], prefills)

  if (country) {
    const countryPreference = getPreferenceByNameAndType(country, 'country', preferences)
    if (countryPreference) {
      countryPreference.type = 'country'
      prefilledPreferences.push(countryPreference)
    }
  }

  return prefilledPreferences
}

function getPreferenceByNameAndType(name, type, preferences) {
  return preferences[type].find((preference) => preference.name === name)
}

function convertPreferenceTypeName(preferenceType) {
  if (['industry', 'size', 'country'].includes(preferenceType)) {
    return `company_${preferenceType}`
  } else if (preferenceType == 'goal') {
    return 'company_goals'
  } else {
    return `${preferenceType}s`
  }
}

export function getPreferenceLogData(selectedPreferences) {
  const initialPreferenceLog = {
    company_industry: '',
    company_size: '',
    company_country: '',
    company_goals: [],
    crm_email_integrations: [],
    helpdesk_integrations: [],
    other_integrations: [],
  }

  // Populate the result object with names from the data array
  selectedPreferences.forEach(({ name, type }) => {
    const preferenceType = convertPreferenceTypeName(type)
    // in type => industry, size, country reutn as string not Array
    if (['company_industry', 'company_size', 'company_country'].includes(preferenceType)) {
      initialPreferenceLog[preferenceType] = name
    } else {
      initialPreferenceLog[preferenceType].push(name)
    }
  })

  return initialPreferenceLog
}

export async function convertUrlToBase64(url) {
  if (!url || typeof url !== 'string') {
    return null
  }

  // Check if URL is already a base64 string
  const base64Pattern = /^data:image\/(png|jpeg|jpg|gif|webp);base64,/
  if (base64Pattern.test(url)) {
    return url // It's already in Base64 format
  }

  try {
    const response = await axios.get(url, {
      responseType: 'arraybuffer',
    })

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    })

    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result)
      reader.onerror = () => reject(new Error('Failed to read image file'))
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    throw new Error(
      `Image conversion failed: ${error instanceof Error ? error.message : 'Unknown error'}`
    )
  }
}

export function processLogoData(prefills) {
  const logos = R.prop('logos', prefills) || []
  const logosExcludingLightTheme = logos.filter((logo) => logo.theme !== 'light')
  const logoData = logosExcludingLightTheme.flatMap((logo) =>
    logo.formats
      .filter((format) => format.width && format.height)
      .map((format) => ({
        id: uuid(),
        src: format.src,
        isUploaded: false,
      }))
  )
  return logoData
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Onboarding/utils.js